export const translations = {
  es: {
    // Navbar
    'nav.inicio': 'Inicio',
    'nav.servicios': 'Servicios',
    'nav.comoFunciona': 'Cómo Funciona',
    'nav.contacto': 'Contacto',
    'nav.evaluacionGratis': 'Evaluación Gratis',

    // Hero
    'hero.headline': '¿Recibes pagos por tarjetas en tu negocio?',
    'hero.subheadline':
      'No importa la cantidad que procesas, yo te puedo ayudar',
    'hero.description':
      'Analizamos tu estado de cuenta actual y solo te ofrecemos cambiar si realmente podemos mejorar tu situación.',
    'hero.cta.primary': 'Solicita tu evaluación gratis online',
    'hero.cta.secondary': 'Sube tu estado de cuenta',
    'hero.cta.tertiary': 'Programar una visita en persona',

    // Value Props
    'valueProps.1.title': 'Tarifas competitivas desde 0%',
    'valueProps.1.desc':
      'Ofrecemos las mejores tarifas del mercado para negocios establecidos',
    'valueProps.2.title': 'POS y terminales modernas',
    'valueProps.2.desc': 'Equipos de última generación para tu negocio',
    'valueProps.3.title': 'Atención en español',
    'valueProps.3.desc':
      'Todo nuestro equipo habla español y entiende tu negocio',
    'valueProps.4.title': 'Sin contratos largos',
    'valueProps.4.desc':
      'Flexibilidad total, sin ataduras ni compromisos extensos',
    'valueProps.5.title': 'Integración y soporte local',
    'valueProps.5.desc':
      'Servicio personalizado y soporte técnico cuando lo necesites',

    // How It Works
    'howItWorks.title': 'Cómo Funciona',
    'howItWorks.subtitle':
      'Un proceso simple y transparente diseñado para tu tranquilidad',
    'howItWorks.step1.title': 'Envía tu estado de cuenta actual',
    'howItWorks.step1.desc':
      'Comparte tu merchant statement más reciente para que podamos analizarlo.',
    'howItWorks.step2.title': 'Analizamos fees, servicio y operación',
    'howItWorks.step2.desc':
      'Revisamos cada detalle: tarifas, cargos ocultos, servicio y equipo.',
    'howItWorks.step3.title':
      'Solo te presentamos una opción si realmente mejora tu situación',
    'howItWorks.step3.desc':
      'Sin presión. Si no podemos mejorar lo que tienes, te lo decimos honestamente.',
    'howItWorks.cta': 'Comienza tu evaluación',

    // Why Choose Us
    'whyChoose.title': '¿Por Qué Elegirnos?',
    'whyChoose.subtitle':
      'Nos diferenciamos por nuestra honestidad y compromiso con tu éxito',
    'whyChoose.1.title': 'Enfoque transparente',
    'whyChoose.1.desc':
      'No hay sorpresas ni cargos ocultos. Todo es claro desde el principio.',
    'whyChoose.2.title': 'Sin presión de ventas',
    'whyChoose.2.desc':
      'Consultamos, no vendemos. Tu mejor interés es nuestra prioridad.',
    'whyChoose.3.title': 'Soluciones para tu negocio',
    'whyChoose.3.desc':
      'POS, terminales, integración a medida según tus necesidades.',
    'whyChoose.4.title': 'Soporte local en español',
    'whyChoose.4.desc':
      'Equipo dedicado que habla tu idioma y entiende tu cultura.',
    'whyChoose.5.title': 'Diseñado para negocios establecidos',
    'whyChoose.5.desc':
      'Trabajamos con empresas serias que procesan $30K+/mes.',

    // Ideal Clients
    'idealClients.title': '¿Es esto para ti?',
    'idealClients.subtitle':
      'Trabajamos con negocios establecidos que procesan más de $30,000 al mes',
    'idealClients.1': 'Retail',
    'idealClients.2': 'Restaurantes',
    'idealClients.3': 'Concesionarios',
    'idealClients.4': 'Servicios profesionales',
    'idealClients.5': 'Oficinas',
    'idealClients.6': 'Otros negocios establecidos',

    // FAQ
    'faq.title': 'Preguntas Frecuentes',
    'faq.subtitle': 'Respuestas a las dudas más comunes',
    'faq.1.q': '¿Qué necesito para recibir una evaluación?',
    'faq.1.a':
      'Solo tu estado de cuenta (merchant statement) más reciente. Con eso podemos analizar tus tarifas actuales y determinar si podemos ofrecerte mejores condiciones.',
    'faq.2.q': '¿Tiene costo revisar mi estado de cuenta?',
    'faq.2.a':
      'No. La evaluación es completamente gratuita y sin compromiso. No hay ningún costo por revisar tu información.',
    'faq.3.q': '¿Qué pasa si no pueden mejorar mi situación?',
    'faq.3.a':
      'Te lo decimos honestamente. No te presionamos para cambiar si no podemos ofrecerte mejores condiciones. Nuestra reputación se basa en la transparencia.',
    'faq.4.q': '¿Ofrecen POS y terminales?',
    'faq.4.a':
      'Sí. Ofrecemos terminales modernas, sistemas POS completos y opciones de integración con tu software actual.',
    'faq.5.q': '¿Hay contratos largos?',
    'faq.5.a':
      'No. Trabajamos sin contratos a largo plazo. Creemos que debes quedarte con nosotros porque estás satisfecho, no porque estés atrapado.',
    'faq.6.q': '¿Atienden en español?',
    'faq.6.a':
      'Sí. Todo nuestro equipo habla español. Entendemos la importancia de comunicarnos en tu idioma y conocer tu cultura de negocios.',

    // Final CTA
    'finalCta.title': 'Tu negocio merece mejores condiciones',
    'finalCta.desc':
      'No te pedimos que cambies sin razón. Primero analizamos tu situación actual y solo te presentamos una propuesta si realmente podemos ayudarte a ahorrar o mejorar tu servicio.',
    'finalCta.button': 'Solicita tu evaluación gratuita',
    'finalCta.trust':
      'Sin compromiso • Análisis gratuito • Respuesta en 24-48 horas',

    // Footer
    'footer.tagline': 'Procesamiento de pagos + POS | Atención en español',
    'footer.quickLinks': 'Enlaces Rápidos',
    'footer.contact': 'Contacto',
    'footer.copyright': 'Todos los derechos reservados.',

    // Contact Page
    'contact.title': 'Solicita tu evaluación gratuita',
    'contact.subtitle':
      'Completa el formulario y un especialista revisará tu información.',
    'contact.form.name': 'Nombre *',
    'contact.form.company': 'Empresa *',
    'contact.form.phone': 'Teléfono *',
    'contact.form.email': 'Email *',
    'contact.form.city': 'Ciudad / Estado *',
    'contact.form.volume': '¿Cuánto procesas al mes? *',
    'contact.form.hasPos': '¿Tienes POS actual? *',
    'contact.form.provider': '¿Quién es tu proveedor actual?',
    'contact.form.message': 'Mensaje',
    'contact.form.statement': 'Estado de cuenta (Merchant Statement)',
    'contact.form.selectOption': 'Selecciona una opción',
    'contact.form.yes': 'Sí',
    'contact.form.no': 'No',
    'contact.form.providerPlaceholder': 'Ej: Square, Clover, etc.',
    'contact.form.messagePlaceholder':
      'Cuéntanos sobre tu negocio o cualquier pregunta que tengas... o dinos si deseas que te visitemos personalmente.',
    'contact.form.dragDrop':
      'Arrastra tu archivo aquí o haz clic para seleccionar',
    'contact.form.selectFile': 'Seleccionar archivo',
    'contact.form.fileTypes': 'PDF, JPG, PNG (máx. 10MB)',
    'contact.form.submit': 'Enviar para evaluación',
    'contact.form.submitting': 'Enviando...',
    'contact.form.trust':
      '🔒 Revisamos tu información con confidencialidad. Solo te contactamos si vemos una oportunidad real de mejora.',
    'contact.form.error.general':
      'Hubo un error al enviar el formulario. Por favor intenta de nuevo.',
    'contact.form.error.network':
      'Error de conexión. Por favor verifica tu internet e intenta de nuevo.',

    // Thank You Page
    'thanks.title': '¡Gracias por tu solicitud!',
    'thanks.message':
      'Hemos recibido tu información. Un especialista la revisará en las próximas 24-48 horas.',
    'thanks.commitment.title': 'Nuestro compromiso:',
    'thanks.commitment.text':
      'Si vemos una oportunidad real para mejorar fees, servicio o POS, nos pondremos en contacto contigo. Si no podemos mejorar tu situación actual, te lo diremos honestamente.',
    'thanks.backHome': 'Volver al inicio',
    'thanks.questions': '¿Tienes preguntas? Contáctanos al',
  },
  en: {
    // Navbar
    'nav.inicio': 'Home',
    'nav.servicios': 'Services',
    'nav.comoFunciona': 'How It Works',
    'nav.contacto': 'Contact',
    'nav.evaluacionGratis': 'Free Evaluation',

    // Hero
    'hero.headline': 'Do you accept card payments at your business?',
    'hero.subheadline': 'No matter how much you process, I can help you',
    'hero.description':
      'We analyze your current statement and only offer a change if we can truly improve your situation.',
    'hero.cta.primary': 'Request your free online evaluation',
    'hero.cta.secondary': 'Upload your statement',
    'hero.cta.tertiary': 'Schedule an in-person visit',

    // Value Props
    'valueProps.1.title': 'Competitive rates starting at 0%',
    'valueProps.1.desc':
      'We offer the best market rates for established businesses',
    'valueProps.2.title': 'Modern POS & terminals',
    'valueProps.2.desc': 'State-of-the-art equipment for your business',
    'valueProps.3.title': 'Bilingual support',
    'valueProps.3.desc':
      'Our entire team speaks English and Spanish and understands your business',
    'valueProps.4.title': 'No long-term contracts',
    'valueProps.4.desc':
      'Total flexibility, no strings attached or lengthy commitments',
    'valueProps.5.title': 'Local integration & support',
    'valueProps.5.desc':
      'Personalized service and technical support when you need it',

    // How It Works
    'howItWorks.title': 'How It Works',
    'howItWorks.subtitle':
      'A simple and transparent process designed for your peace of mind',
    'howItWorks.step1.title': 'Send your current statement',
    'howItWorks.step1.desc':
      'Share your most recent merchant statement so we can analyze it.',
    'howItWorks.step2.title': 'We analyze fees, service, and operations',
    'howItWorks.step2.desc':
      'We review every detail: rates, hidden fees, service, and equipment.',
    'howItWorks.step3.title':
      'We only present an option if it truly improves your situation',
    'howItWorks.step3.desc':
      "No pressure. If we can't improve what you have, we'll tell you honestly.",
    'howItWorks.cta': 'Start your evaluation',

    // Why Choose Us
    'whyChoose.title': 'Why Choose Us?',
    'whyChoose.subtitle':
      'We stand out for our honesty and commitment to your success',
    'whyChoose.1.title': 'Transparent approach',
    'whyChoose.1.desc':
      'No surprises or hidden fees. Everything is clear from the start.',
    'whyChoose.2.title': 'No sales pressure',
    'whyChoose.2.desc':
      "We consult, we don't sell. Your best interest is our priority.",
    'whyChoose.3.title': 'Solutions for your business',
    'whyChoose.3.desc':
      'POS, terminals, custom integration according to your needs.',
    'whyChoose.4.title': 'Local bilingual support',
    'whyChoose.4.desc':
      'Dedicated team that speaks your language and understands your culture.',
    'whyChoose.5.title': 'Designed for established businesses',
    'whyChoose.5.desc':
      'We work with serious companies processing $30K+/month.',

    // Ideal Clients
    'idealClients.title': 'Is this for you?',
    'idealClients.subtitle':
      'We work with established businesses processing over $30,000 a month',
    'idealClients.1': 'Retail',
    'idealClients.2': 'Restaurants',
    'idealClients.3': 'Dealerships',
    'idealClients.4': 'Professional services',
    'idealClients.5': 'Offices',
    'idealClients.6': 'Other established businesses',

    // FAQ
    'faq.title': 'Frequently Asked Questions',
    'faq.subtitle': 'Answers to the most common questions',
    'faq.1.q': 'What do I need to receive an evaluation?',
    'faq.1.a':
      'Just your most recent merchant statement. With that, we can analyze your current rates and determine if we can offer you better conditions.',
    'faq.2.q': 'Is there a cost to review my statement?',
    'faq.2.a':
      'No. The evaluation is completely free and without obligation. There is no cost to review your information.',
    'faq.3.q': "What happens if you can't improve my situation?",
    'faq.3.a':
      "We will tell you honestly. We don't pressure you to switch if we can't offer better conditions. Our reputation is built on transparency.",
    'faq.4.q': 'Do you offer POS and terminals?',
    'faq.4.a':
      'Yes. We offer modern terminals, complete POS systems, and integration options with your current software.',
    'faq.5.q': 'Are there long-term contracts?',
    'faq.5.a':
      'No. We work without long-term contracts. We believe you should stay with us because you are satisfied, not because you are trapped.',
    'faq.6.q': 'Do you provide support in Spanish?',
    'faq.6.a':
      'Yes. Our entire team is fully bilingual in English and Spanish.',

    // Final CTA
    'finalCta.title': 'Your business deserves better conditions',
    'finalCta.desc':
      "We don't ask you to switch for no reason. First, we analyze your current situation and only present a proposal if we can truly help you save or improve your service.",
    'finalCta.button': 'Request your free evaluation',
    'finalCta.trust': 'No commitment • Free analysis • Response in 24-48 hours',

    // Footer
    'footer.tagline': 'Payment processing + POS | Bilingual support',
    'footer.quickLinks': 'Quick Links',
    'footer.contact': 'Contact',
    'footer.copyright': 'All rights reserved.',

    // Contact Page
    'contact.title': 'Request your free evaluation',
    'contact.subtitle':
      'Complete the form and a specialist will review your information.',
    'contact.form.name': 'Name *',
    'contact.form.company': 'Company *',
    'contact.form.phone': 'Phone *',
    'contact.form.email': 'Email *',
    'contact.form.city': 'City / State *',
    'contact.form.volume': 'How much do you process per month? *',
    'contact.form.hasPos': 'Do you have a current POS? *',
    'contact.form.provider': 'Who is your current provider?',
    'contact.form.message': 'Message',
    'contact.form.statement': 'Merchant Statement',
    'contact.form.selectOption': 'Select an option',
    'contact.form.yes': 'Yes',
    'contact.form.no': 'No',
    'contact.form.providerPlaceholder': 'Ej: Square, Clover, etc.',
    'contact.form.messagePlaceholder':
      "Tell us about your business or any questions you have... or let us know if you'd like an in-person visit.",
    'contact.form.dragDrop': 'Drag your file here or click to select',
    'contact.form.selectFile': 'Select file',
    'contact.form.fileTypes': 'PDF, JPG, PNG (max. 10MB)',
    'contact.form.submit': 'Send for evaluation',
    'contact.form.submitting': 'Sending...',
    'contact.form.trust':
      '🔒 We review your information confidentially. We only contact you if we see a real opportunity for improvement.',
    'contact.form.error.general':
      'There was an error submitting the form. Please try again.',
    'contact.form.error.network':
      'Connection error. Please check your internet and try again.',

    // Thank You Page
    'thanks.title': 'Thank you for your request!',
    'thanks.message':
      'We have received your information. A specialist will review it within the next 24-48 hours.',
    'thanks.commitment.title': 'Our commitment:',
    'thanks.commitment.text':
      'If we see a real opportunity to improve fees, service, or POS, we will contact you. If we cannot improve your current situation, we will tell you honestly.',
    'thanks.backHome': 'Back to home',
    'thanks.questions': 'Have questions? Contact us at',
  },
}

export type Language = 'es' | 'en'
export type TranslationKey = keyof typeof translations.es
